import { isPresent } from '@farmai-shared/LFUtils';
import { callAgroApi } from '@services/agroapi';
import { LabelResponse } from '@services/responseTypes';
import { Transformers } from '@services/transformer';
import { castToSnapshot } from 'mobx-state-tree';
export const withLabels = self => ({
  actions: {
    fetchLabels({
      page = 1,
      search,
      labelIds
    }: {
      page?: number;
      search?: string;
      labelIds?: string[];
    }) {
      const queryParams = new URLSearchParams();
      if (isPresent(labelIds)) {
        labelIds.forEach(name => queryParams.append('filter[label_id][]', name));
      }
      if (search) {
        queryParams.set('filter[query]', search);
      }
      queryParams.set('page', page.toString());
      return callAgroApi<LabelResponse[]>(`/organizations/${self.id}/labels?${queryParams.toString()}`, 'GET').then(({
        data
      }) => data.map(d => self.pushToLabels(d)));
    },
    pushToLabels(label: LabelResponse) {
      const transformed = Transformers.lbl(label);
      self.labelStore.labels.put(castToSnapshot(transformed));
      return transformed;
    },
    fetchLabel(id: string) {
      return callAgroApi<LabelResponse>(`/organizations/${self.id}/labels/${id}`, 'GET').then(({
        data
      }) => Transformers.lbl(data));
    },
    createLabel(label: {
      name: string;
      description?: string;
      color: string;
    }) {
      return callAgroApi<LabelResponse>(`/organizations/${self.id}/labels`, 'POST', label);
    },
    updateLabel(label) {
      return callAgroApi<LabelResponse>(`/organizations/${self.id}/labels/${label.id}`, 'PATCH', label);
    },
    deleteLabel(labelId: string) {
      return callAgroApi<LabelResponse>(`/organizations/${self.id}/labels/${labelId}`, 'DELETE');
    }
  }
});